import { Outlet } from "react-router-dom";

import { AppearanceControls } from "@/components/appearance-controls";

/**
 * Signed-in pages that take the whole screen: no rail, no header. The session
 * check lives in PrivateRoute above it; the profile these pages read is already
 * in the query cache by the time one of them paints.
 */
const FullLayout = () => (
  <>
    <Outlet />
    <AppearanceControls />
  </>
);

export default FullLayout;
